// Composables
import { useManagerAuth } from '~/modules/manager/auth/composables/use-auth';
import { useAuthMiddleware } from '~/misc/auth/composables/use-auth-middleware';
import { useAfterManagerLoginRedirectRoute } from '~/modules/manager/auth/composables/use-after-login-redirect-route';

const AUTH_PATHS: string[] = ['manager-login', 'manager-login-passcode'];

export default defineNuxtRouteMiddleware((_to, _from) => {
  const { store, terminate } = useManagerAuth();
  const { set: setAfterLoginRedirectRoute } = useAfterManagerLoginRedirectRoute();

  const { handle } = useAuthMiddleware(
    store,
    terminate,
    AUTH_PATHS,
    '/manager/dashboard',
    '/manager/login',
    setAfterLoginRedirectRoute
  );

  return handle(_to, _from);
});
